import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';

import { typeEnum, sexEnum, identificationTypeEnum } from '@modules/employees/_employeesEnums';

// prettier-ignore
export const employeesGridColumns = [
  { label: 'Osobní číslo', field: 'personalNumber', type: ColumnType.TEXT, width: 80 },
  { label: 'Služební číslo', field: 'officerNumber', type: ColumnType.TEXT, width: 80 },
  { label: 'Pracovní pozice', field: 'positionName', displayField: 'position', mapper: o => get(o, 'name'), type: ColumnType.TEXT, width: 80 },
  { label: 'Datum narození', field: 'birthDate', type: ColumnType.DATE, width: 200 },
  { label: 'Jméno', field: 'firstName', type: ColumnType.TEXT, width: 100 },
  { label: 'Přijmení', field: 'lastName', type: ColumnType.TEXT, width: 100 },
  { label: 'Rodné přijmení', field: 'maidenName', type: ColumnType.TEXT, width: 100 },
  { label: 'Uživatelské jméno', field: 'username', type: ColumnType.TEXT, width: 100 },
  { label: 'Řidičské Opravnění', field: 'driverLicenseTypes', type: ColumnType.TEXT, width: 80 },
  { label: 'Funkce', field: 'type.id', displayField: 'type', type: ColumnType.ENUM, enum: typeEnum, width: 80 },
  { label: 'Adresa', field: 'address.fullAddress', displayField: 'address', mapper: parent => get(parent, 'fullAddress'), type: ColumnType.TEXT, width: 120 },
  { label: 'Vzdělání', field: 'education.name', displayField: 'education', mapper: parent => get(parent, 'name'), type: ColumnType.TEXT, width: 100 },
  { label: 'Telefon', field: 'phone', type: ColumnType.TEXT, width: 80 },
  { label: 'Email', field: 'email', type: ColumnType.TEXT, width: 80 },
  { label: 'Pohlaví', field: 'sex.id', displayField: 'sex', type: ColumnType.ENUM, enum: sexEnum, width: 80 },
];

// prettier-ignore
export const contractsGridColumns = [
  { label: 'Pracovní pozice', field: 'workPosition.name', displayField: 'workPosition', mapper: parent => get(parent, 'name'), type: ColumnType.TEXT, width: 200 },
  { label: 'Od', field: 'start', type: ColumnType.DATE, width: 200 },
  { label: 'Do', field: 'end', type: ColumnType.DATE, width: 200 },
];

// prettier-ignore
export const identificationsGridColumns = [
  { label: 'Typ dokladu', field: 'type', type: ColumnType.ENUM, enum: identificationTypeEnum, width: 80 },
  { label: 'Datum vydání', field: 'issuedOn', type: ColumnType.DATE, width: 200 },
  { label: 'Platnost do', field: 'validTo', type: ColumnType.DATE, width: 200 },
  { label: 'Číslo dokladu', field: 'value', type: ColumnType.TEXT, width: 200 }
];

// prettier-ignore
export const filesGridColumns = [
  { label: 'Název', field: 'fileRef.name', displayField: 'fileRef', mapper: parent => get(parent, 'name'), type: ColumnType.TEXT, width: 200 },
  { label: 'Popis', field: 'description', type: ColumnType.TEXT, width: 200 },
];

// prettier-ignore
export const trainingsGridColumns = [
  { label: 'Poznámka', field: 'note', type: ColumnType.TEXT, width: 200 },
  { label: 'Datum absolvování', field: 'absolved', type: ColumnType.DATE, width: 200 }
];

// prettier-ignore
export const certificatesGridColumns = [
  { label: 'Typ', field: 'type.name', displayField: 'type', mapper: parent => get(parent, 'name'), type: ColumnType.TEXT, width: 200 },
  { label: 'Datum absolvování', field: 'absolved', type: ColumnType.DATE, width: 200 },
  { label: 'Platnost', field: 'validTo', type: ColumnType.DATE, width: 200 },
  { label: 'Poznámka', field: 'note', type: ColumnType.TEXT, width: 200 }
];



// WEBPACK FOOTER //
// ./src/modules/employees/_employeesColumns.ts